import { useState } from 'react'

import type { SalesKind } from '../../lib/business'
import PaymentsPage from './PaymentsPage'
import SalesPage from './SalesPage'

// Quotations, orders, invoices and payments are one workflow, so they are one
// screen with tabs rather than four sidebar entries. Fewer places to look.
const TABS: Array<{ key: string; label: string; hint: string }> = [
  { key: 'quotations', label: 'Quotations', hint: 'What you offered' },
  { key: 'sales-orders', label: 'Orders', hint: 'What they accepted' },
  { key: 'invoices', label: 'Invoices', hint: 'What you billed' },
  { key: 'payments', label: 'Payments', hint: 'What they paid' },
]

export default function SalesHub() {
  const [tab, setTab] = useState('quotations')

  return (
    <div style={{ display: 'grid', gap: 14 }}>
      <div className="tabs">
        {TABS.map((t, i) => (
          <button
            key={t.key}
            className={`tab${tab === t.key ? ' active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            <span className="tab-step">{i + 1}</span>
            <span>
              <span className="tab-label">{t.label}</span>
              <span className="tab-hint">{t.hint}</span>
            </span>
          </button>
        ))}
      </div>

      {tab === 'payments'
        ? <PaymentsPage />
        : <SalesPage key={tab} kind={tab as SalesKind} />}
    </div>
  )
}
